import { callApi } from '@/api/apibase'

export const getGreenCourseSystemSettings = function () {
  return callApi('GET', `/api/external/greencourse/getgreencoursesystemsettings`)
}
